<template>
  <div v-if="personCurrent" class="acc-page">
    <div class="container">
      <div class="acc-dropzone col-md-12">
        <Dropzone/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Info from '@/components/Users/Info';
import AccStat from '@/components/Account/Stat';
import Dropzone from '@/components/Account/Dropzone';

export default {
  name: 'Upload',
  components: {
    Dropzone,
    AccStat,
    Info,
  },
  computed: mapGetters({
    personCurrent: 'personCurrent',
  }),
  data() {
    return {
      title: 'Страница пользователя',
    };
  },
  metaInfo() {
    return {
      title: this.title,
    };
  },
  methods: {
    updateTitle() {
      this.title = this.personCurrent.first_name ? `${this.personCurrent.first_name} ${this.personCurrent.last_name}` : 'Страница пользователя';
    },
  },
  mounted() {
    this.updateTitle();
  },
};
</script>

<style>
  .acc{
    &-page{
      padding: 10vh 0px;
      .separator{
        border-bottom: dotted 1px #ccc;
        display: inline-block;
        margin-bottom: 40px;
        min-height: 1px;
        width: 100%;
      }

      @media (max-width: 600px){
        padding: 10px 0px;
      }
    }
    &-info{
      text-align: center;
      .user--info-photo,
      .user--info-avatar{
        margin-left: -75px;
        margin-bottom: 3px;
        line-height: 2.25;
        font-size: 440%;
        height: 130px;
        width: 130px;
      }
      &-name{
        margin-bottom: 6px;
        margin-top: 30px;
      }
    }
    &-dropzone{
      margin-top: 0;
    }

  }
</style>



// WEBPACK FOOTER //
// Upload.vue?5211416b